export default "__VITE_PUBLIC_ASSET__1e85243f__"